import styled from 'styled-components';
import { fadeIn } from './Animations';

/**
 * Container principal da página
 * Usado em páginas de listagem
 */
export const Container = styled.div`
    width: 100%;
    min-height: calc(100vh - 65px);
    background-color: #f3f4f6;
    font-family: 'Mulish', sans-serif;
    box-sizing: border-box;
    overflow-x: hidden;
`;

/**
 * Container moderno para páginas de formulário
 * Usado em páginas de edição/criação
 */
export const ModernContainer = styled.div`
    min-height: 100vh;
    background-color: #f3f4f6;
    font-family: 'Mulish', sans-serif;
`;

/**
 * Header moderno sem fundo
 * Alinhado com o conteúdo
 */
export const ModernHeader = styled.div`
    max-width: 1200px;
    margin: 0 auto 2.5rem;
    padding: 3rem 2rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    animation: ${fadeIn} 0.6s ease;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        padding: 2rem 1rem 0;
    }
`;

/**
 * Lado esquerdo do header (ícone + título)
 */
export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
`;

/**
 * Conteúdo do header (título e subtítulo)
 */
export const HeaderContent = styled.div`
    flex: 1;
`;

/**
 * Título da página
 */
export const PageTitle = styled.h1`
    font-size: 1.8rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 0.5rem 0;
    display: flex;
    align-items: center;
    font-family: 'Mulish', sans-serif;

    @media (max-width: 768px) {
        font-size: 1.5rem;
    }
`;

/**
 * Subtítulo da página
 */
export const PageSubtitle = styled.p`
    font-size: 1rem;
    color: #6b7280;
    margin: 0;
    font-family: 'Mulish', sans-serif;

    @media (max-width: 768px) {
        font-size: 0.9rem;
    }
`;

/**
 * Título do header em formulários
 */
export const HeaderTitle = styled.h1`
    font-size: 28px;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
`;

/**
 * Subtítulo do header
 */
export const HeaderSubtitle = styled.p`
    font-size: 14px;
    color: #7f8c8d;
    margin: 0;
`;

/**
 * Container de ações do header (botões)
 */
export const HeaderActions = styled.div`
    display: flex;
    gap: 12px;

    @media (max-width: 768px) {
        width: 100%;
        flex-direction: column;
    }
`;

/**
 * Barra de ações em formulários
 */
export const ActionBar = styled.div`
    background: white;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 24px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
    animation: ${fadeIn} 0.7s ease;
    max-width: 1200px;
    margin: 0 auto 24px;
    box-sizing: border-box;
`;

/**
 * Grupo de ações (botões lado a lado)
 */
export const ActionGroup = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
`;

/**
 * Formulário base
 */
export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

/**
 * Informações de seção (título + contador)
 */
export const SectionInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 24px;
    padding-top: 24px;
`;

/**
 * Título de seção
 */
export const SectionInfoTitle = styled.h3`
    margin: 0;
    font-size: 20px;
    color: #1f2933;
    font-family: 'Mulish', sans-serif;
`;

/**
 * Subtítulo de seção (contador, descrição)
 */
export const SectionSubtitle = styled.span`
    font-size: 14px;
    color: #64748b;
    font-family: 'Mulish', sans-serif;
`;

/**
 * Container de página usando o novo layout system
 */
export const Page = styled.div`
    width: 100%;
    min-height: calc(100vh - 65px);
    background-color: #f3f4f6;
    font-family: 'Mulish', sans-serif;
    box-sizing: border-box;
`;
